// 统一请求路径前缀在commmon/axios.js中修改
import { getRequest, postRequest,deleteRequest,postRequestLogin,putRequest,putNoToken,getRequestWithNoToken } from '../assets/js/api';

// 1.查询儿童接口
export const _getChildren = (params) => {
   return getRequest('/api-customer-c/psy_student/switch/list', params)
}

// 2.查询星座枚举
export const _getSigns = (params) => {
   return getRequest('/api-customer-c/enums?enumName=cn.com.futongdf.psyc.customer.common.constant.SignsEnum', params)
}

// 3.根据身份证计算生日 年龄 星座 接口
export const _getBirthdayAndAgeAndSigns = (idCard) => {
   return getRequest('/api-customer-c/psy_student/birthdayAndAgeAndSigns/'+ idCard)
}

// 4.文件上传接口
export const _getupload = (params) => {
   return postRequest('/api-file/file/upload', params)
}

// 5.查询单个儿童接口
export const _getChild= (studentId) => {
   return getRequest('/api-customer-c/psy_student/'+ studentId)
}

// 6.新增/保存(更新)儿童接口
export const _saveChild= (params) => {
   return postRequest('/api-customer-c/psy_student',params)
}

// 7.保存爱好或者标签接口
export const _saveFavoriteLabel= (params) => {
   return postRequest('/api-customer-c/studentFavoriteLabelCustom/save',params)
}
// 单个保存自定义爱好或者标签接口
export const _saveSingleFavoriteLabel= (params) => {
   return postRequest('/api-customer-c/studentFavoriteLabelCustom/singleSave',params)
}


// 8.保存照片墙接口
export const _saveStudentPhotoWall= (params) => {
   return postRequest('/api-customer-c/studentPhotoWall',params)
}

// 9.标签或者爱好模糊查询
export const _getPage= (params) => {
   return postRequest('/api-common/label-content/invoke/page',params)
}

// 10.字典查询
export const _getList= (code) => {
   return getRequest('/api-common/dict-item/invoke/list?code='+ code)
}

// 11.删除儿童标签爱好接口
export const _delFavoriteLabel= (id) => {
   return deleteRequest('/api-customer-c/studentFavoriteLabelCustom/'+id)
}

// 12.查询儿童标签爱好接口 
export const _getFavoriteLabel= (params) => {
   return postRequest('/api-customer-c/studentFavoriteLabelCustom/queryLabels',params)
}



